<template>
  <section id="test-panel-block" v-loading="loading">
    <div class="container-small-table">
      <div class="test-panels">
        <div class="inner-content">
          <div v-if="labPanels.length !== 0">
            <el-row gutter="30">
              <el-col :xl="5" :lg="6" :md="6" :sm="10" :xs="24">
                <div class="inner-col">
                  <h4 class="heading">TEST PANELS</h4>
                </div>

                <div class="inner-col mt-10">
                  <ul class="panels-list" v-if="labPanels.length">
                    <li
                      class="panels-listing"
                      v-for="(panel, index) of labPanels"
                      :key="index"
                      :class="getActiveClass(panel.code)"
                    >
                      <img
                        src="@/assets/images/icons/confirmation-tests-inactive.svg"
                        alt=""
                        class="img-inactive"
                      />
                      <img
                        src="@/assets/images/icons/confirmation-tests-active.svg"
                        alt=""
                        class="img-active"
                      />

                      <p
                        class="panel-test-names"
                        @click="showExistedPanelTests(panel.code)"
                        :class="panel.status.toLowerCase()"
                      >
                        {{ panel.name }}
                      </p>
                    </li>
                  </ul>
                </div>
              </el-col>
              <el-col :xl="19" :lg="18" :md="8" :sm="14" :xs="24">
                <div class="inner-col">
                  <PanelTests
                    v-if="showTestSelection"
                    :isNew="newPanel"
                    :panelValue="selectedPanel"
                    :labId="labId"
                  ></PanelTests>
                </div>
              </el-col>
            </el-row>
          </div>
          <div v-if="labPanels.length == 0">
            <div style="padding: 30px">No Tests Configured</div>
          </div>
        </div>
      </div>

      <div class="vue-model add-test-model">
        <el-dialog
          top="5vh"
          v-model="showTestPanelSelectionDialogVisible"
          width="80%"
          :before-close="closeAddTests"
        >
          <AddTests
            v-if="showTestPanelSelectionDialogVisible"
            :labId="labId"
            :isNew="true"
            v-on:addTestsData="closeAddTests"
            v-on:addedPanel="updatePanels"
            :existedPanels="labPanels"
          />
        </el-dialog>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import PanelTests from "./PanelTests";
import AddTests from "./panels/AddTests";
export default {
  components: {
    PanelTests,
    AddTests,
  },
  data() {
    return {
      formdata: "",
      layout: "div",
      value: {},
      isSelected: null,
      checkList: [],
      cardloading: false,
      loading: false,
      params: {
        lab_id: this.$route.params.lab_id,
        panelType: "",
        details: false,
      },
      dialogFormVisible: false,
      detailCardvisible: false,
      labPanels: [],
      showTestPanelSelectionDialogVisible: false,
      defaultPanels: [],
      selectedNewTestPanel: "",
      labId: "",
      selectedPanel: "",
      showTestSelection: false,
      newPanel: false,
      displayPanel: "",
      status: ["ACTIVE", "INACTIVE"],
    };
  },
  computed: {
    ...mapGetters("testpanel", ["getAllTestPanels"]),
    ...mapGetters("labs", ["getTestPanels"]),
    getActiveClasstList() {
      return (path) => {
        if (path == this.$route.path.split("/").pop()) {
          return "router-link-exact-active";
        } else return "";
      };
    },
    isReportPage() {
      return this.$route.query && this.$route.query.add_panels;
    },
  },
  mounted() {
    this.fetchNecessaryData();
  },
  methods: {
    async fetchLabTestPanelsDetails() {
      this.loading = true;
      try {
        await this.$store.dispatch("labs/fetchTestPanels", {
          lab_id: this.labId,
          get_all: true,
          status: this.status,
        });
        this.labTestPanels = this.getTestPanels;
        this.labPanels = this.getTestPanels;
        if (this.labPanels && this.labPanels.length) {
          await this.showExistedPanelTests(this.labPanels[0]);
        }
      } catch (error) {
        this.labTestPanels = [];
      }
      this.loading = false;
    },

    async fetchAllTestPanels() {
      this.loading = true;
      try {
        await this.$store.dispatch("testpanel/fetchTestPanels");
        this.defaultPanels = [
          {
            case_name: "Covid",
            name: "Covid",
            label: "Covid",
            value: "COVID",
            code: "COVID",
            reporting: true,
          },
          {
            case_name: "Respiratory Panel",
            name: "Respiratory Panel",
            label: "Respiratory Panel",
            value: "RESPIRATORY_PATHOGEN_PANEL",
            code: "RESPIRATORY_PATHOGEN_PANEL",
            reporting: true,
          },
          {
            case_name: "Clinical Chemistry",
            name: "Clinical Chemistry",
            label: "Clinical Chemistry",
            value: "CLINICAL_CHEMISTRY",
            code: "CLINICAL_CHEMISTRY",
            reporting: false,
          },
          {
            case_name: "UTI",
            name: "UTI",
            label: "UTI",
            value: "UTI",
            code: "UTI",
            reporting: true,
          },
          {
            case_name: "PGX Test",
            name: "PGX Test",
            value: "PGX_TEST",
            code: "PGX_TEST",
            label: "PGX_TEST",
            reporting: false,
          },
        ];
      } catch (error) {
        this.labTestPanels = [];
      }
      this.loading = false;
    },
    async fetchNecessaryData() {
      this.labId = this.$route.params.lab_id;
      await this.fetchLabTestPanelsDetails();
      await this.fetchAllTestPanels();
      if (this.labPanels && this.labPanels.length) {
        this.displayPanel = this.labPanels[0].code;
        this.showExistedPanelTests(this.labPanels[0].code);
      }
    },
    async takeTestPanel() {
      this.showTestPanelSelectionDialogVisible = true;

      this.newPanel = true;
    },

    showExistedPanelTests(value) {
      this.newPanel = false;
      this.showTestSelection = false;
      this.selectedPanel = value;

      setTimeout(() => {
        this.showTestSelection = true;
      }, 1);
    },
    checkAlreadyExisted(panel) {
      let existedPanel = this.labPanels.find(
        (panelE) => panelE.code == panel.code
      );

      return existedPanel ? true : false;
    },
    async refreshPanels() {
      this.showTestSelection = false;
      await this.fetchLabTestPanelsDetails();
      this.showExistedPanelTests(this.displayPanel);
      this.showTestSelection = true;
    },
    closeAddTests() {
      this.showTestPanelSelectionDialogVisible = false;
      let query = {
        selectedLabPage: this.$route.query.selectedLabPage,
        selectedLabPageSize: this.$route.query.selectedLabPageSize,
        selectedLabString: this.$route.query.selectedLabString,
        selectedLabSearchBy: this.$route.query.selectedLabSearchBy,
        selectedOrderBy: this.$route.query.selectedOrderBy,
        redirectRoute: this.$route.query.redirectRoute,
        selectedOrderType: this.$route.query.selectedOrderType,
        add_panels: undefined,
      };

      this.$router.push({ query });
    },
    updatePanels(panelValue) {
      this.showTestPanelSelectionDialogVisible = false;

      if (panelValue) {
        this.displayPanel = panelValue;
        this.refreshPanels();
      }
      let query = {
        selectedLabPage: this.$route.query.selectedLabPage,
        selectedLabPageSize: this.$route.query.selectedLabPageSize,
        selectedLabString: this.$route.query.selectedLabString,
        selectedLabSearchBy: this.$route.query.selectedLabSearchBy,
        selectedOrderBy: this.$route.query.selectedOrderBy,
        selectedOrderType: this.$route.query.selectedOrderType,
        redirectRoute: this.$route.query.redirectRoute,
        add_panels: undefined,
      };

      this.$router.push({ query });
    },
    getActiveClass(panel) {
      return this.selectedPanel == panel ? "active" : "";
    },
  },
  watch: {
    async "$route.query.add_panels"() {
      if (this.isReportPage) {
        this.takeTestPanel();
      }
    },
  },
};
</script>
<style lang="scss">
#test-panel-block {
  .test-panels {
    .inner-content {
      .inner-col {
        padding: 10px 20px;
        background: #ffffff;
        border: 0.633951px solid #e0e0e0;
        border-radius: 5px;

        .panels-list {
          .panels-listing {
            display: flex;
            align-items: center;
            color: #bdbdbd;
            padding: 10px 0;
            font-weight: 500;
            cursor: pointer;
            img {
              padding-bottom: 3px;
              padding-right: 10px;
            }
            .img-active {
              display: none;
            }
          }

          .active {
            color: green;
            .img-inactive {
              display: none;
            }
            .img-active {
              display: block;
            }
          }
          .inactive {
            color: red;
          }
        }
      }
    }
  }
  .el-dialog {
    border-radius: 10px 10px 0 0;
  }
  .c_body .add-test-button .el-button {
    background-color: #273480;
  }
}
</style>
